namespace Matrix.Administration {
    export interface UserRow {
        Username?: string;
        Email?: string;
        FullName?: string;
        PasswordHash?: string;
        ProfileImage?: string;
        RoleNames?: string[];
        Groups?: string[];
        GroupRoles?: string[];
        IsActive?: number;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        Password?: string;
        PasswordConfirm?: string;
    }

    export namespace UserRow {
        export const idProperty = 'Username';
        export const isActiveProperty = 'IsActive';
        export const nameProperty = 'Username';
        export const localTextPrefix = 'Administration.User';
        export const lookupKey = 'Administration.User';

        export function getLookup(): Q.Lookup<UserRow> {
            return Q.getLookup<UserRow>('Administration.User');
        }
        export const deletePermission = 'Administration:Security';
        export const insertPermission = 'Administration:Security';
        export const readPermission = 'Administration:Security';
        export const updatePermission = 'Administration:Security';

        export declare const enum Fields {
            Username = "Username",
            Email = "Email",
            FullName = "FullName",
            PasswordHash = "PasswordHash",
            ProfileImage = "ProfileImage",
            RoleNames = "RoleNames",
            Groups = "Groups",
            GroupRoles = "GroupRoles",
            IsActive = "IsActive",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            Password = "Password",
            PasswordConfirm = "PasswordConfirm"
        }
    }
}
